(function () {
  var ROOT_SELECTOR = '[data-product-upsell-upload]';
  var trackedSubmitter = null;
  var instances = [];

  function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }

  function buildFormData(form, submitter) {
    try {
      return submitter ? new FormData(form, submitter) : new FormData(form);
    } catch (error) {
      var formData = new FormData(form);

      if (submitter && submitter.name) {
        formData.append(submitter.name, submitter.value || '');
      }

      return formData;
    }
  }

  function getPropertyName(name) {
    var match = name && name.match(/^properties\[([^\]]+)\]$/);
    return match ? match[1] : '';
  }

  function resolveMainProductForm(productId) {
    var summaryForm = document.getElementById('ws-product-form-summary');
    if (summaryForm) return summaryForm;

    var forms = toArray(document.querySelectorAll('form[action*="/cart/add"], form[action*="javascript"]'));

    for (var i = 0; i < forms.length; i += 1) {
      var form = forms[i];
      if (!form || form.closest(ROOT_SELECTOR)) continue;

      var productIdNode =
        form.querySelector('input[name="product-id"]') ||
        form.querySelector('input[name="product_id"]') ||
        form.querySelector('[data-product-id]');

      if (!productIdNode) continue;

      var candidateId = productIdNode.value || productIdNode.getAttribute('data-product-id') || '';
      if (String(candidateId) === String(productId)) return form;
    }

    return forms.find(function (form) {
      return form && !form.closest(ROOT_SELECTOR);
    }) || null;
  }

  function resolveMainDataForm(mainForm) {
    var bcpoRoot = document.getElementById('bcpo');
    var bcpoForm = bcpoRoot && bcpoRoot.closest ? bcpoRoot.closest('form[action*="/cart/add"], form[action*="javascript"]') : null;

    if (bcpoForm && !bcpoForm.closest(ROOT_SELECTOR)) {
      return bcpoForm;
    }

    if (mainForm && mainForm.id !== 'ws-product-form-summary') {
      return mainForm;
    }

    return (
      document.querySelector('form[data-ws-product-form]') ||
      document.querySelector('form[action*="/cart/add"]:not(#ws-product-form-summary)') ||
      document.querySelector('form.product-form:not(#ws-product-form-summary)') ||
      mainForm
    );
  }

  function getCurrentVariantId(mainForm) {
    var candidates = [
      document.querySelector('#bcpo-select'),
      document.querySelector('select[name="vopo-id"]'),
      document.querySelector('input[name="vopo-id"]'),
      document.querySelector('[data-product-master-select]'),
      document.querySelector('form[data-ws-product-form] input[name="id"]'),
      document.querySelector('form[action*="/cart/add"]:not(#ws-product-form-summary) input[name="id"]'),
      mainForm ? mainForm.querySelector('input[name="id"], select[name="id"]') : null,
      document.querySelector('input[name="id"], select[name="id"]')
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (node && node.value) return String(node.value);
    }

    return '';
  }

  function getCurrentQuantity(mainForm, formData) {
    var candidates = [
      mainForm ? mainForm.querySelector('input[name="quantity"]') : null,
      document.querySelector('form[data-ws-product-form] input[name="quantity"]'),
      document.querySelector('form[action*="/cart/add"]:not(#ws-product-form-summary) input[name="quantity"]'),
      document.querySelector('input[name="quantity"]'),
      document.querySelector('#Quantity'),
      document.querySelector('.quantity__input')
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!node || !node.value) continue;

      var parsed = parseInt(node.value, 10);
      if (Number.isFinite(parsed) && parsed > 0) return String(parsed);
    }

    var fallback = parseInt((formData && formData.get('quantity')) || '1', 10);
    return String(Number.isFinite(fallback) && fallback > 0 ? fallback : 1);
  }

  function getVisibleWrapperValue(wrapper) {
    if (!wrapper) return '';

    var valueEl = wrapper.querySelector('.bcpo-value');
    if (valueEl) {
      var valueText = (valueEl.textContent || '').trim();
      if (valueText) return valueText;
    }

    var checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      return (checkedRadio.value || '').trim();
    }

    var checkedCheckboxes = toArray(wrapper.querySelectorAll('input[type="checkbox"]:checked')).map(function (node) {
      return (node.value || '').trim();
    }).filter(Boolean);

    if (checkedCheckboxes.length) {
      return checkedCheckboxes.join(', ');
    }

    var select = wrapper.querySelector('select[name^="properties["], select.single-option-selector, select');
    if (select) {
      var option = select.options && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
      var selectValue = (option ? option.textContent : select.value || '').trim();
      if (selectValue) return selectValue;
    }

    var activeImage = wrapper.querySelector('.bcpo-image-parent.ws-active input, .bcpo-image-parent input:checked');
    if (activeImage && activeImage.value) {
      return String(activeImage.value).trim();
    }

    return '';
  }

  function getSelectedSelectValue(wrapper) {
    if (!wrapper) return '';

    var select = wrapper.querySelector('select[name^="properties["], select.single-option-selector, select');
    if (!select) return '';

    var option = select.options && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
    return (option ? option.textContent : select.value || '').trim();
  }

  function isUpsellPropertyNode(node) {
    return !!(node && node.closest && node.closest(ROOT_SELECTOR));
  }

  function clearPropertyEntries(formData) {
    var keys = [];

    formData.forEach(function (value, key) {
      if (/^properties\[.+\]$/.test(key)) {
        keys.push(key);
      }
    });

    keys.forEach(function (key) {
      formData.delete(key);
    });

    return formData;
  }

  function collectPropertiesFromNodes(nodes) {
    var properties = {};

    toArray(nodes).forEach(function (node) {
      if (!node || !node.name || node.disabled) return;

      var propertyName = getPropertyName(node.name);
      if (!propertyName) return;

      var type = (node.type || '').toLowerCase();
      var value = '';

      if (type === 'radio') {
        if (!node.checked) return;
        value = node.value || '';
      } else if (type === 'checkbox') {
        if (!node.checked) return;
        value = node.value || 'checked';
      } else {
        value = node.value || '';
      }

      if (!value) return;
      properties[propertyName] = String(value);
    });

    return properties;
  }

  function appendMainProductVisibleProperties(formData) {
    var existing = {};

    formData.forEach(function (value, key) {
      var match = key && key.match(/^properties\[(.+)\]$/);
      if (!match) return;
      existing[match[1]] = true;
    });

    toArray(document.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]')).forEach(function (node) {
      if (!node.name || node.disabled) return;
      if (isUpsellPropertyNode(node)) return;

      var match = node.name.match(/^properties\[(.+)\]$/);
      if (!match) return;

      var propertyName = match[1];
      if (existing[propertyName]) return;

      var type = (node.type || '').toLowerCase();
      var value = '';

      if (type === 'checkbox' || type === 'radio') {
        if (!node.checked) return;
        value = node.value || '';
      } else {
        value = node.value || '';
      }

      if (value === '') return;

      formData.append(node.name, value);
      existing[propertyName] = true;
    });

    return formData;
  }

  function appendMainProductVariantSelections(formData) {
    var existing = {};

    formData.forEach(function (value, key) {
      var match = key && key.match(/^properties\[(.+)\]$/);
      if (!match) return;
      existing[(match[1] || '').trim().toLowerCase()] = true;
    });

    toArray(document.querySelectorAll('#bcpo .selector-wrapper')).forEach(function (wrapper) {
      if (!wrapper || wrapper.classList.contains('bcpo-instructions')) return;

      var titleEl = wrapper.querySelector('.bcpo-title');
      var label = titleEl ? titleEl.textContent.replace(/:$/, '').trim() : '';
      var value = getVisibleWrapperValue(wrapper) || getSelectedSelectValue(wrapper);
      var normalized = label.toLowerCase();

      if (!label || !value || existing[normalized]) return;

      formData.append('properties[' + label + ']', value);
      existing[normalized] = true;
    });

    return formData;
  }

  function appendMainProductNotesProperty(formData) {
    if (!formData) return formData;

    var uiTextarea = document.querySelector('#ws-notes-ui');
    var realField = document.querySelector(
      'input[name="properties[Istruzioni per la Stampa]"],' +
      'input[name="properties[Istruzioni per la stampa]"],' +
      'textarea[name="properties[Istruzioni per la Stampa]"],' +
      'textarea[name="properties[Istruzioni per la stampa]"],' +
      'input[id^="istruzioni-per-la-stampa"],' +
      'textarea[id^="istruzioni-per-la-stampa"]'
    );

    var notesValue = '';

    if (uiTextarea && uiTextarea.value) {
      notesValue = String(uiTextarea.value);
    } else if (realField && realField.value) {
      notesValue = String(realField.value);
    }

    if (!notesValue.trim()) {
      return formData;
    }

    if (realField) {
      realField.value = notesValue;
      realField.dispatchEvent(new Event('input', { bubbles: true }));
      realField.dispatchEvent(new Event('change', { bubbles: true }));
    }

    formData.delete('properties[Istruzioni per la Stampa]');
    formData.delete('properties[Istruzioni per la stampa]');
    formData.append('properties[Istruzioni per la stampa]', notesValue);

    return formData;
  }

  function parseUploadliftState(nodes) {
    var fileValue = '';
    var nativeProperties = {};

    toArray(nodes).forEach(function (node) {
      if (!node) return;

      var tagName = node.tagName ? node.tagName.toLowerCase() : '';
      var type = (node.getAttribute('type') || '').toLowerCase();
      var name = node.getAttribute('name') || '';
      var value = '';

      if (tagName === 'a') {
        value = node.getAttribute('href') || '';
      } else if (type === 'checkbox' || type === 'radio') {
        value = node.checked ? (node.value || 'checked') : '';
      } else {
        value = node.value || '';
      }

      if (!value) return;

      if (name.indexOf('properties[') === 0) {
        nativeProperties[name] = value;
      }

      if (
        !fileValue &&
        /^https?:\/\//i.test(value) &&
        (
          name.indexOf('properties[') === 0 ||
          /upload|file|url|link|thumbnail|pond|lift/i.test(name) ||
          /upload|file|url|link|thumbnail|pond|lift/i.test(node.id || '') ||
          /cloudlift|cdn\.shopify|cloudfront|amazonaws|upload/i.test(value)
        )
      ) {
        fileValue = value;
      }
    });

    return {
      fileValue: fileValue,
      nativeProperties: nativeProperties
    };
  }

  function collectMainUploadliftState() {
    var roots = toArray(document.querySelectorAll('[data-ws-upload-lift-host], [data-upload-lift], .cl-upload--wrapper, .filepond--root.cl-upload--area')).filter(function (node) {
      return node && !(node.closest && node.closest(ROOT_SELECTOR));
    });

    if (!roots.length) {
      roots = [document];
    }

    var combined = {
      fileValue: '',
      nativeProperties: {}
    };

    roots.forEach(function (root) {
      var nodes = root.querySelectorAll('input, textarea, select, a[href]');
      var state = parseUploadliftState(nodes);

      if (!combined.fileValue && state.fileValue) combined.fileValue = state.fileValue;

      Object.keys(state.nativeProperties).forEach(function (name) {
        combined.nativeProperties[name] = state.nativeProperties[name];
      });
    });

    return combined;
  }

  function mergeUploadliftStateIntoFormData(formData, uploadliftState) {
    if (!formData || !uploadliftState) return formData;

    Object.keys(uploadliftState.nativeProperties || {}).forEach(function (name) {
      if (name.indexOf('properties[') !== 0) return;
      formData.delete(name);
      formData.append(name, uploadliftState.nativeProperties[name]);
    });

    return formData;
  }

  function buildMainProductFormData(mainForm, submitter) {
    var sourceForm = resolveMainDataForm(mainForm);
    if (!sourceForm) {
      throw new Error('Form prodotto principale non trovato.');
    }

    var safeSubmitter = submitter && submitter.form === sourceForm ? submitter : null;
    var formData = buildFormData(sourceForm, safeSubmitter);

    if (mainForm && mainForm.id === 'ws-product-form-summary') {
      clearPropertyEntries(formData);
      appendMainProductVisibleProperties(formData);
      appendMainProductVariantSelections(formData);
    }

    appendMainProductNotesProperty(formData);

    var variantId = getCurrentVariantId(mainForm || sourceForm);
    if (!variantId) {
      throw new Error('Variante del prodotto principale non trovata.');
    }

    formData.set('id', variantId);
    formData.set('quantity', getCurrentQuantity(mainForm || sourceForm, formData));
    mergeUploadliftStateIntoFormData(formData, collectMainUploadliftState());

    return formData;
  }

  function postCartAdd(body) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (data) {
        if (!response.ok) {
          throw new Error((data && (data.description || data.message)) || 'Errore durante l’aggiunta al carrello.');
        }

        return data;
      });
    });
  }

  function addMainProduct(formData) {
    return postCartAdd(formData);
  }

  function addUpsellProduct(payload) {
    var formData = new FormData();
    formData.append('id', String(payload.id));
    formData.append('quantity', String(payload.quantity || 1));

    Object.keys(payload.properties || {}).forEach(function (name) {
      var value = payload.properties[name];
      if (value == null || value === '') return;
      formData.append('properties[' + name + ']', String(value));
    });

    return postCartAdd(formData);
  }

  function getPreviewCard() {
    return document.querySelector('[data-ws-card="anteprima"]');
  }

  function wantsPreviewAddon() {
    var state = window.__wsPreviewState;
    if (state && typeof state === 'object') {
      return !!state.wantsAddon;
    }

    var card = getPreviewCard();
    if (!card) return false;

    if (card.getAttribute('data-ws-preview-selected') === 'true') return true;

    var checked = card.querySelector('[data-ws-preview-choice]:checked');
    return !!(checked && checked.value === 'yes');
  }

  function ensurePreviewAddonData() {
    var card = getPreviewCard();
    if (!card) {
      return Promise.resolve({ id: 0, price: 0 });
    }

    var currentId = parseInt(card.getAttribute('data-ws-preview-addon-id') || '', 10);
    var currentPrice = parseInt(card.getAttribute('data-ws-preview-addon-price') || '0', 10) || 0;

    if (currentId) {
      return Promise.resolve({
        id: currentId,
        price: currentPrice
      });
    }

    var handle = card.getAttribute('data-ws-preview-addon-handle') || 'anteprima-di-stampa';

    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: {
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Impossibile recuperare il prodotto anteprima.');
      }

      return response.json();
    }).then(function (previewProduct) {
      var previewVariant = null;

      if (previewProduct && previewProduct.variants && previewProduct.variants.length) {
        for (var i = 0; i < previewProduct.variants.length; i += 1) {
          if (previewProduct.variants[i].available) {
            previewVariant = previewProduct.variants[i];
            break;
          }
        }

        if (!previewVariant) {
          previewVariant = previewProduct.variants[0];
        }
      }

      if (!previewVariant || !previewVariant.id) {
        throw new Error('Variant ID anteprima non trovato.');
      }

      card.setAttribute('data-ws-preview-addon-id', String(previewVariant.id));
      card.setAttribute('data-ws-preview-addon-price', String(parseInt(previewVariant.price, 10) || 0));

      return {
        id: parseInt(previewVariant.id, 10),
        price: parseInt(previewVariant.price, 10) || 0
      };
    }).catch(function () {
      return {
        id: 0,
        price: currentPrice
      };
    });
  }

  function getFormPropertyEntries(formData) {
    var entries = [];

    formData.forEach(function (value, key) {
      var match = key && key.match(/^properties\[(.+)\]$/);
      if (!match) return;

      entries.push({
        key: key,
        name: match[1],
        value: value == null ? '' : String(value)
      });
    });

    return entries;
  }

  function looksLikeUploadedFileProperty(entry) {
    if (!entry || !entry.name || !entry.value) return false;
    if (entry.name.charAt(0) === '_') return false;
    if (/^anteprima di stampa/i.test(entry.name)) return false;
    if (/^prodotto$/i.test(entry.name)) return false;

    var normalizedValue = entry.value.toLowerCase();
    return (
      normalizedValue.indexOf('cloudlift.app') !== -1 ||
      normalizedValue.indexOf('cdn.shopify.com') !== -1 ||
      normalizedValue.indexOf('/cdn/shop/') !== -1 ||
      normalizedValue.indexOf('/files/') !== -1 ||
      normalizedValue.indexOf('http://') === 0 ||
      normalizedValue.indexOf('https://') === 0
    );
  }

  function collectPreviewAddonFileProperties(mainFormData) {
    var fileProperties = {};
    var seen = {};

    function addEntry(entry) {
      if (!looksLikeUploadedFileProperty(entry)) return;

      var key = entry.name + '::' + entry.value;
      if (seen[key]) return;

      seen[key] = true;
      if (typeof fileProperties[entry.name] === 'undefined') {
        fileProperties[entry.name] = entry.value;
      }
    }

    getFormPropertyEntries(mainFormData).forEach(addEntry);

    return fileProperties;
  }

  function buildPreviewAddonProperties(mainForm, mainFormData) {
    var properties = {
      prodotto: (mainForm && mainForm.getAttribute('data-ws-product-title')) || document.title || 'Prodotto'
    };

    var fileProperties = collectPreviewAddonFileProperties(mainFormData);
    Object.keys(fileProperties).forEach(function (name) {
      properties[name] = fileProperties[name];
    });

    return properties;
  }

  function snapshotPropertiesFromContainer(container) {
    if (!container) {
      return {
        properties: {},
        hasUploadValue: false,
        hasUploadInProgress: false
      };
    }

    var visibleUploadWrappers = toArray(container.querySelectorAll('.cl-upload--wrapper')).filter(function (wrapper) {
      var host = wrapper.closest('[data-ws-upload-lift-host], [data-upload-lift]');
      return !wrapper.hidden && !(host && host.hidden);
    });
    var scopedNodes = visibleUploadWrappers.length
      ? visibleUploadWrappers.reduce(function (nodes, wrapper) {
          return nodes.concat(toArray(wrapper.querySelectorAll('input, textarea, select, a[href]')));
        }, [])
      : toArray(container.querySelectorAll('input, textarea, select, a[href]'));
    var uploadliftState = parseUploadliftState(scopedNodes);
    var properties = {};
    var hasUploadValue = !!uploadliftState.fileValue;
    var hasUploadInProgress = false;

    Object.keys(uploadliftState.nativeProperties).forEach(function (name) {
      if (name.indexOf('properties[') !== 0) return;
      properties[getPropertyName(name)] = String(uploadliftState.nativeProperties[name]);
    });

    if (container.querySelector('.filepond--item.is-processing, .filepond--file-status-main')) {
      var statuses = toArray(container.querySelectorAll('.filepond--file-status-main')).map(function (node) {
        return (node.textContent || '').trim().toLowerCase();
      }).join(' ');

      if (/processing|caricamento|uploading|attendi|preparing/.test(statuses)) {
        hasUploadInProgress = true;
      }
    }

    return {
      properties: properties,
      hasUploadValue: hasUploadValue,
      hasUploadInProgress: hasUploadInProgress
    };
  }

  function isPositiveInteger(value) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0;
  }

  function normalizeUploadValue(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getNormalizedUploadPosition(value) {
    var normalized = normalizeUploadValue(value);
    if (!normalized) return '';
    if (normalized.indexOf('lato cuore') > -1 || normalized === 'cuore') return 'lato-cuore';
    if (normalized.indexOf('fronte') > -1 || normalized.indexOf('front') > -1 || normalized.indexOf('davanti') > -1) return 'fronte';
    if (normalized.indexOf('retro') > -1 || normalized.indexOf('back') > -1 || normalized.indexOf('dietro') > -1) return 'retro';
    return '';
  }

  function getRequiredUploadPositions(value) {
    return String(value || '')
      .split('+')
      .map(function (part) {
        return getNormalizedUploadPosition(part);
      })
      .filter(Boolean);
  }

  function getUploadWrapperPosition(wrapper) {
    if (!wrapper) return '';
    var labelNode = wrapper.querySelector('.cl-upload--label');
    var fieldCandidates = [
      labelNode ? labelNode.textContent : '',
      wrapper.getAttribute('data-field-name') || '',
      wrapper.getAttribute('data-name') || '',
      toArray(wrapper.querySelectorAll('input[name], textarea[name], select[name]')).map(function (node) {
        return node.getAttribute('name') || '';
      }).join(' ')
    ];

    for (var i = 0; i < fieldCandidates.length; i += 1) {
      var position = getNormalizedUploadPosition(fieldCandidates[i]);
      if (position) return position;
    }

    return '';
  }

  function getUploadHostNode(node) {
    if (!node || !node.closest) return null;
    return node.closest('[data-ws-upload-lift-host]') || node.closest('[data-upload-lift]') || node.closest('.cl-upload--wrapper');
  }

  function mountUpsellUploadIntoContainer(root, container, selector) {
    if (!container || !selector) return false;

    var moved = false;

    if (window.wsUploadHelpers && typeof window.wsUploadHelpers.moveUploadLiftIntoCard === 'function') {
      try {
        moved = !!window.wsUploadHelpers.moveUploadLiftIntoCard({
          scope: document,
          slot: container,
          uploadBlockSelector: selector
        });
      } catch (error) {}
    }

    if (!moved) {
      toArray(document.querySelectorAll(selector)).forEach(function (node) {
        if (!node || container.contains(node)) return;

        var uploadRoot = null;

        if (node.matches && node.matches('[data-upload-lift]')) {
          uploadRoot = node;
        } else if (node.closest) {
          uploadRoot = node.closest('[data-upload-lift]') || node.closest('[data-ws-upload-lift-host]') || node.closest('.cl-upload--wrapper');
        }

        if (!uploadRoot) {
          uploadRoot = node;
        }

        if (!container.contains(uploadRoot)) {
          container.appendChild(uploadRoot);
          moved = true;
        }
      });
    }

    if (moved) {
      container.removeAttribute('data-upload-disabled');
      root.classList.add('has-live-upload');
    }

    return moved;
  }

  function ProductUpsellUpload(root) {
    this.root = root;
    this.productId = root.getAttribute('data-product-id') || '';
    this.upsellVariantId = root.getAttribute('data-upsell-variant-id') || '';
    this.uploadRequired = root.getAttribute('data-upload-required') === 'true';
    this.uploadSelector = root.getAttribute('data-upload-lift-selector') || '';
    this.button = root.querySelector('[data-upsell-toggle]');
    this.buttonLabel = root.querySelector('[data-upsell-toggle-label]');
    this.statusNode = root.querySelector('[data-upsell-status]');
    this.errorNode = root.querySelector('[data-upsell-error]');
    this.uploadContainer = root.querySelector('[data-upsell-upload-container]');
    this.optionsRoot = root.querySelector('[data-upsell-options-root]');
    this.optionsPanel = root.querySelector('[data-upsell-options-panel]');
    this.optionsToggle = root.querySelector('[data-upsell-options-toggle]');
    this.summaryNode = root.querySelector('[data-upsell-summary]');
    this.variantJsonNode = root.querySelector('[data-upsell-variants-json]');
    this.modalEnabled = !!(this.optionsRoot && this.optionsRoot.getAttribute('data-upsell-modal-enabled') === 'true');
    this.upsellProductUrl = this.optionsRoot ? (this.optionsRoot.getAttribute('data-upsell-product-url') || '') : '';
    this.modalNode = root.querySelector('[data-upsell-modal]');
    this.modalFrame = root.querySelector('[data-upsell-modal-frame]');
    this.modalConfirm = root.querySelector('[data-upsell-modal-confirm]');
    this.modalCloseButtons = toArray(root.querySelectorAll('[data-upsell-modal-close]'));
    this.variantOptions = [];
    this.optionInputs = toArray(root.querySelectorAll('[data-upsell-option-input]'));
    this.colorInputs = toArray(root.querySelectorAll('.product-upsell-upload__color-swatch input[type="radio"]'));
    this.sizeInputs = toArray(root.querySelectorAll('.product-upsell-upload__size-input'));
    this.sizeTotalNode = root.querySelector('[data-upsell-size-total]');
    this.sizeTotalInput = root.querySelector('[data-upsell-size-total-input]');
    this.sizeErrorNode = root.querySelector('[data-upsell-size-message], [data-upsell-size-error]');
    this.positionInputs = toArray(root.querySelectorAll('[data-upsell-position]'));
    this.sizeLimit = parseInt((this.optionsRoot && this.optionsRoot.getAttribute('data-upsell-pack-limit')) || '10', 10);
    this.underLimitMessage = this.optionsRoot ? (this.optionsRoot.getAttribute('data-upsell-under-limit-message') || 'Hai selezionato meno pezzi del richiesto. Completa la distribuzione taglie.') : 'Hai selezionato meno pezzi del richiesto. Completa la distribuzione taglie.';
    this.overLimitMessage = this.optionsRoot ? (this.optionsRoot.getAttribute('data-upsell-over-limit-message') || 'Hai selezionato più pezzi del consentito. Riduci il totale delle taglie.') : 'Hai selezionato più pezzi del consentito. Riduci il totale delle taglie.';
    if (!Number.isFinite(this.sizeLimit) || this.sizeLimit < 1) {
      this.sizeLimit = 10;
    }
    this.defaultLabel = this.button ? this.button.getAttribute('data-default-label') || '' : '';
    this.selectedLabel = this.button ? this.button.getAttribute('data-selected-label') || 'Prodotto selezionato' : '';
    this.loadingLabel = this.button ? this.button.getAttribute('data-loading-label') || 'Attendi...' : '';
    this.isSubmitting = false;
    this.preparedUpsell = null;
    this.uploadMounted = false;
    this.uploadObserver = null;
    this.uploadContentObserver = null;
    this.remoteConfiguratorReady = false;
    this.remoteConfiguratorState = null;
    this.init();
  }

  ProductUpsellUpload.prototype.init = function () {
    var self = this;
    if (!self.button) return;

    self.initOptions();

    self.button.addEventListener('click', function () {
      if (self.isSubmitting) return;

      self.clearMessages();

      if (self.isSelected()) {
        self.preparedUpsell = null;
        self.setSelected(false);
        return;
      }

      try {
        self.preparedUpsell = self.prepareUpsellState();
        self.setSelected(true);
        self.showStatus('Prodotto upsell pronto per l’aggiunta al carrello.');
      } catch (error) {
        self.preparedUpsell = null;
        self.setSelected(false);
        self.showError(error && error.message ? error.message : 'Errore nella preparazione dell’upsell.');
      }
    });

    self.bindMainFormInterceptors();
    self.bindConfiguratorModal();
    self.mountUploadLift();
  };

  ProductUpsellUpload.prototype.initOptions = function () {
    var self = this;
    if (!self.optionsRoot) return;

    if (self.variantJsonNode) {
      try {
        self.variantOptions = JSON.parse(self.variantJsonNode.textContent || '[]');
      } catch (error) {
        self.variantOptions = [];
      }
    }

    if (self.optionsToggle) {
      self.optionsToggle.addEventListener('click', function () {
        if (self.modalEnabled) {
          self.openConfiguratorModal();
          return;
        }
        self.setOptionsExpanded(self.optionsRoot.getAttribute('data-expanded') !== 'true');
      });
    }

    self.optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        self.syncOptionPills();
        self.syncVariantFromOptions();
        self.syncSummary();
      });
    });

    self.colorInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        self.syncColorSwatches();
        self.syncSummary();
      });
    });

    self.sizeInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        var numericValue = parseInt(input.value || '0', 10);

        if (!Number.isFinite(numericValue) || numericValue < 0) {
          input.value = '0';
        } else if (numericValue > self.sizeLimit) {
          input.value = String(self.sizeLimit);
        }

        self.syncSizeTotals();
        self.syncSummary();
      });
    });

    self.positionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        self.syncVariantFromPosition();
        self.syncRadioCards();
        self.syncSummary();
        self.scheduleUploadVisibilitySync();
      });
    });

    self.optionInputs.forEach(function (input) {
      if (normalizeUploadValue(input.getAttribute('data-option-name')) !== 'posizione stampa') return;

      input.addEventListener('change', function () {
        self.scheduleUploadVisibilitySync();
      });
    });

    self.syncOptionPills();
    self.syncColorSwatches();
    self.syncSizeTotals();
    self.syncRadioCards();
    self.syncVariantFromOptions();
    self.syncVariantFromPosition();
    self.syncSummary();
    self.scheduleUploadVisibilitySync();
  };

  ProductUpsellUpload.prototype.bindConfiguratorModal = function () {
    var self = this;
    if (!self.modalEnabled || !self.modalNode || !self.modalFrame) return;

    self.modalCloseButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.closeConfiguratorModal();
      });
    });

    if (self.modalConfirm) {
      self.modalConfirm.addEventListener('click', function () {
        self.confirmRemoteConfigurator();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.modalNode && !self.modalNode.hidden) {
        self.closeConfiguratorModal();
      }
    });
  };

  ProductUpsellUpload.prototype.openConfiguratorModal = function () {
    if (!this.modalNode || !this.modalFrame || !this.upsellProductUrl) return;

    this.modalNode.hidden = false;
    document.documentElement.classList.add('product-upsell-upload-modal-open');

    if (!this.modalFrame.getAttribute('src')) {
      this.modalFrame.setAttribute('src', this.upsellProductUrl);
    }
  };

  ProductUpsellUpload.prototype.closeConfiguratorModal = function () {
    if (!this.modalNode) return;
    this.modalNode.hidden = true;
    document.documentElement.classList.remove('product-upsell-upload-modal-open');
  };

  ProductUpsellUpload.prototype.collectRemoteConfiguratorState = function () {
    if (!this.modalFrame || !this.modalFrame.contentDocument) {
      throw new Error('Configuratore upsell non disponibile.');
    }

    var doc = this.modalFrame.contentDocument;
    var mainForm = doc.getElementById('ws-product-form-summary') ||
      doc.querySelector('form[data-ws-product-form]') ||
      doc.querySelector('form[action*="/cart/add"]');

    if (!mainForm) {
      throw new Error('Form upsell non trovato.');
    }

    var variantCandidates = [
      doc.querySelector('#bcpo-select'),
      doc.querySelector('select[name="vopo-id"]'),
      doc.querySelector('input[name="vopo-id"]'),
      doc.querySelector('[data-product-master-select]'),
      mainForm.querySelector('input[name="id"], select[name="id"]'),
      doc.querySelector('input[name="id"], select[name="id"]')
    ];

    var variantId = '';
    variantCandidates.some(function (node) {
      if (node && node.value) {
        variantId = String(node.value);
        return true;
      }
      return false;
    });

    if (!variantId) {
      throw new Error('Variante upsell non trovata.');
    }

    var properties = collectPropertiesFromNodes(
      doc.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]')
    );

    var groupedOptions = [];
    toArray(doc.querySelectorAll('#bcpo .selector-wrapper')).forEach(function (wrapper) {
      if (!wrapper || wrapper.classList.contains('bcpo-instructions')) return;

      var titleEl = wrapper.querySelector('.bcpo-title');
      var label = titleEl ? String(titleEl.textContent || '').replace(/:$/, '').trim() : '';
      var value = getVisibleWrapperValue(wrapper) || getSelectedSelectValue(wrapper);

      if (!label || !value) return;
      properties[label] = String(value);
      groupedOptions.push(label + ': ' + value);
    });

    return {
      id: parseInt(variantId, 10),
      quantity: 1,
      properties: properties,
      summary: groupedOptions.join(' • ')
    };
  };

  ProductUpsellUpload.prototype.confirmRemoteConfigurator = function () {
    try {
      var state = this.collectRemoteConfiguratorState();
      this.remoteConfiguratorState = state;
      this.updateVariantId(state.id);
      if (this.summaryNode) {
        this.summaryNode.textContent = state.summary || 'Opzioni configurate.';
      }
      this.preparedUpsell = null;
      this.closeConfiguratorModal();
      this.syncUploadVisibilityByPosition();
      this.scheduleUploadVisibilitySync();
      this.showStatus('Opzioni upsell confermate.');
    } catch (error) {
      this.showError(error && error.message ? error.message : 'Errore nella configurazione dell’upsell.');
    }
  };

  ProductUpsellUpload.prototype.setOptionsExpanded = function (expanded) {
    if (!this.optionsRoot || !this.optionsToggle || !this.optionsPanel) return;

    var expandLabel = this.optionsToggle.getAttribute('data-expand-label') || 'Mostra opzioni';
    var collapseLabel = this.optionsToggle.getAttribute('data-collapse-label') || 'Mostra meno';

    this.optionsRoot.setAttribute('data-expanded', expanded ? 'true' : 'false');
    this.optionsToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    this.optionsToggle.textContent = expanded ? collapseLabel : expandLabel;
    this.optionsPanel.hidden = !expanded;
  };

  ProductUpsellUpload.prototype.syncOptionPills = function () {
    this.optionInputs.forEach(function (input) {
      var label = input.closest('.product-upsell-upload__option-pill');
      if (!label) return;
      label.classList.toggle('is-active', !!input.checked);
    });
  };

  ProductUpsellUpload.prototype.syncColorSwatches = function () {
    this.colorInputs.forEach(function (input) {
      var label = input.closest('.product-upsell-upload__color-swatch');
      if (!label) return;
      label.classList.toggle('is-active', !!input.checked);
    });
  };

  ProductUpsellUpload.prototype.syncRadioCards = function () {
    this.positionInputs.forEach(function (input) {
      var label = input.closest('.product-upsell-upload__radio-card');
      if (!label) return;
      label.classList.toggle('is-active', !!input.checked);
    });
  };

  ProductUpsellUpload.prototype.syncSizeTotals = function () {
    var total = this.sizeInputs.reduce(function (sum, input) {
      var value = parseInt(input.value || '0', 10);
      return sum + (Number.isFinite(value) && value > 0 ? value : 0);
    }, 0);

    if (this.sizeTotalNode) {
      this.sizeTotalNode.textContent = String(total);
    }

    if (this.sizeTotalInput) {
      this.sizeTotalInput.value = String(total);
    }

    if (this.sizeErrorNode) {
      if (!this.sizeInputs.length || total === 0 || total === this.sizeLimit) {
        this.sizeErrorNode.hidden = true;
        this.sizeErrorNode.textContent = '';
      } else if (total < this.sizeLimit) {
        this.sizeErrorNode.hidden = false;
        this.sizeErrorNode.textContent = this.underLimitMessage;
      } else {
        this.sizeErrorNode.hidden = false;
        this.sizeErrorNode.textContent = this.overLimitMessage;
      }
    }

    return total;
  };

  ProductUpsellUpload.prototype.updateVariantId = function (variantId) {
    if (!variantId) return;

    this.upsellVariantId = String(variantId);
    this.root.setAttribute('data-upsell-variant-id', this.upsellVariantId);

    toArray(this.root.querySelectorAll('[data-upsell-variant-id]')).forEach(function (node) {
      node.setAttribute('data-upsell-variant-id', String(variantId));
    });
  };

  ProductUpsellUpload.prototype.syncVariantFromOptions = function () {
    var self = this;
    if (!self.variantOptions.length || !self.optionInputs.length) return null;

    var selectedByPosition = {};
    self.optionInputs.forEach(function (input) {
      if (!input.checked) return;
      selectedByPosition[String(input.getAttribute('data-option-position') || '')] = String(input.value || '');
    });

    var matched = self.variantOptions.find(function (variant) {
      if (!variant || !variant.options) return false;

      return variant.options.every(function (optionValue, index) {
        var selectedValue = selectedByPosition[String(index)];
        return !selectedValue || String(optionValue) === selectedValue;
      });
    });

    if (matched && matched.id) {
      self.updateVariantId(matched.id);
      self.syncUploadVisibilityByPosition();
      return matched;
    }

    return null;
  };

  ProductUpsellUpload.prototype.syncVariantFromPosition = function () {
    var selected = this.positionInputs.find(function (input) {
      return input.checked && input.getAttribute('data-variant-id');
    });

    if (selected) {
      this.updateVariantId(selected.getAttribute('data-variant-id'));
    }

    this.syncUploadVisibilityByPosition();
  };

  ProductUpsellUpload.prototype.getSelectedPositionValue = function () {
    if (this.remoteConfiguratorState && this.remoteConfiguratorState.properties) {
      var remotePosition = this.remoteConfiguratorState.properties['Posizione Stampa'] || this.remoteConfiguratorState.properties['Posizione stampa'];
      if (remotePosition) {
        return String(remotePosition);
      }
    }

    var directCheckedInput = this.root.querySelector(
      '[data-option-name="Posizione Stampa"][data-upsell-option-input]:checked,' +
      'input[data-option-name="Posizione Stampa"]:checked,' +
      '[data-upsell-position]:checked'
    );

    if (directCheckedInput && directCheckedInput.value) {
      return String(directCheckedInput.value);
    }

    var selectedPosition = this.positionInputs.find(function (input) {
      return input.checked && input.value;
    });

    if (selectedPosition) {
      return String(selectedPosition.value);
    }

    var selectedVariantOption = this.optionInputs.find(function (input) {
      return input.checked && normalizeUploadValue(input.getAttribute('data-option-name')) === 'posizione stampa';
    });

    if (selectedVariantOption && selectedVariantOption.value) {
      return String(selectedVariantOption.value);
    }

    if (this.summaryNode) {
      var summaryText = String(this.summaryNode.textContent || '');
      var summaryMatch = summaryText.match(/Posizione Stampa:\s*([^•]+)/i) || summaryText.match(/Stampa:\s*([^•]+)/i);
      if (summaryMatch && summaryMatch[1]) {
        return String(summaryMatch[1]).trim();
      }
    }

    return '';
  };

  ProductUpsellUpload.prototype.syncUploadVisibilityByPosition = function () {
    if (!this.uploadContainer) return;

    var wrappers = toArray(this.uploadContainer.querySelectorAll('.cl-upload--wrapper'));
    if (!wrappers.length) return;

    var requiredPositions = getRequiredUploadPositions(this.getSelectedPositionValue());
    var hasFilter = requiredPositions.length > 0;

    wrappers.forEach(function (wrapper) {
      var wrapperPosition = getUploadWrapperPosition(wrapper);
      var shouldShow = !hasFilter || !wrapperPosition || requiredPositions.indexOf(wrapperPosition) > -1;

      wrapper.hidden = !shouldShow;
      wrapper.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      wrapper.setAttribute('data-ws-upload-position', wrapperPosition || 'generic');
      wrapper.setAttribute('data-ws-upload-visible', shouldShow ? 'true' : 'false');
      if (shouldShow) {
        wrapper.style.removeProperty('display');
      } else {
        wrapper.style.setProperty('display', 'none', 'important');
      }
    });

    toArray(this.uploadContainer.querySelectorAll('.ws-upload-group')).forEach(function (group) {
      var hasVisibleWrappers = toArray(group.querySelectorAll('.cl-upload--wrapper')).some(function (wrapper) {
        return !wrapper.hidden;
      });
      group.hidden = !hasVisibleWrappers;
      if (hasVisibleWrappers) {
        group.style.removeProperty('display');
      } else {
        group.style.setProperty('display', 'none', 'important');
      }
    });
  };

  ProductUpsellUpload.prototype.bindUploadContentObserver = function () {
    var self = this;
    if (!self.uploadContainer || self.uploadContentObserver) return;

    self.uploadContentObserver = new MutationObserver(function () {
      self.syncUploadVisibilityByPosition();
    });

    self.uploadContentObserver.observe(self.uploadContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
  };

  ProductUpsellUpload.prototype.scheduleUploadVisibilitySync = function () {
    var self = this;

    [0, 120, 320, 700, 1200].forEach(function (delay) {
      window.setTimeout(function () {
        self.syncUploadVisibilityByPosition();
      }, delay);
    });
  };

  ProductUpsellUpload.prototype.syncSummary = function () {
    if (!this.summaryNode) return;

    if (this.modalEnabled && this.remoteConfiguratorState && this.remoteConfiguratorState.summary) {
      this.summaryNode.textContent = this.remoteConfiguratorState.summary;
      return;
    }

    var parts = [];
    var self = this;
    var groupedOptions = {};
    var selectedPositionValue = '';

    self.optionInputs.forEach(function (input) {
      if (!input.checked) return;
      var optionName = input.getAttribute('data-option-name') || 'Opzione';
      if (normalizeUploadValue(optionName) === 'posizione stampa') {
        selectedPositionValue = input.value || '';
        return;
      }
      groupedOptions[optionName] = input.value || '';
    });

    var colorSelections = {};
    self.colorInputs.forEach(function (input) {
      if (!input.checked || !input.value) return;
      var colorLabel = input.getAttribute('data-color-group-label') || input.getAttribute('data-color-property-name') || 'Colore';
      colorSelections[colorLabel] = String(input.value);
    });

    Object.keys(colorSelections).forEach(function (label) {
      if (!colorSelections[label]) return;
      parts.push(label + ': ' + colorSelections[label]);
    });

    var singleSizeInput = (self.optionsPanel || self.root).querySelector('input[name="properties[Taglia]"]');
    if (singleSizeInput && singleSizeInput.value) {
      parts.push('Taglia: ' + singleSizeInput.value);
    } else {
      var totalSizes = self.syncSizeTotals();
      if (totalSizes > 0) {
        parts.push('Taglie: ' + totalSizes);
      }
    }

    if (!selectedPositionValue) {
      var selectedPosition = self.positionInputs.find(function (input) {
        return input.checked;
      });
      if (selectedPosition && selectedPosition.value) {
        selectedPositionValue = selectedPosition.value;
      }
    }

    if (selectedPositionValue) {
      parts.push('Posizione stampa: ' + selectedPositionValue);
    }

    Object.keys(groupedOptions).forEach(function (name) {
      if (!groupedOptions[name]) return;
      parts.push(name + ': ' + groupedOptions[name]);
    });

    this.summaryNode.textContent = parts.length
      ? parts.join(' • ')
      : 'Seleziona opzioni e personalizzazioni prima di aggiungerlo.';
  };

  ProductUpsellUpload.prototype.collectConfiguratorProperties = function () {
    if (this.modalEnabled) {
      if (!this.remoteConfiguratorState || !this.remoteConfiguratorState.properties) {
        throw new Error('Apri "Mostra opzioni" e conferma prima il configuratore dell’upsell.');
      }

      return Object.assign({}, this.remoteConfiguratorState.properties);
    }

    var properties = {};
    var sizeTotal = this.syncSizeTotals();

    if (this.sizeInputs.length && sizeTotal < this.sizeLimit) {
      throw new Error(this.underLimitMessage);
    }

    if (this.sizeInputs.length && sizeTotal > this.sizeLimit) {
      throw new Error(this.overLimitMessage);
    }

    var positionProperties = {};
    var additionalOptionProperties = {};

    toArray((this.optionsPanel || this.root).querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]')).forEach(function (node) {
      if (!node.name || node.disabled) return;

      var propertyName = getPropertyName(node.name);
      if (!propertyName) return;

      var type = (node.type || '').toLowerCase();
      var value = '';

      if (type === 'radio') {
        if (!node.checked) return;
        value = node.value || '';
      } else if (type === 'checkbox') {
        if (!node.checked) return;
        value = node.value || 'checked';
      } else {
        value = node.value || '';
      }

      if (!value) return;

      if (/^taglia /i.test(propertyName) && !isPositiveInteger(value)) {
        return;
      }

      if (propertyName === 'Totale taglie') {
        return;
      }

      properties[propertyName] = String(value);
    });

    this.optionInputs.forEach(function (input) {
      if (!input.checked) return;
      var optionName = input.getAttribute('data-option-name') || '';
      if (!optionName || !input.value) return;

      if (normalizeUploadValue(optionName) === 'posizione stampa') {
        positionProperties[optionName] = String(input.value);
      } else {
        additionalOptionProperties[optionName] = String(input.value);
      }
    });

    Object.keys(positionProperties).forEach(function (name) {
      properties[name] = positionProperties[name];
    });

    Object.keys(additionalOptionProperties).forEach(function (name) {
      properties[name] = additionalOptionProperties[name];
    });

    return properties;
  };

  ProductUpsellUpload.prototype.isSelected = function () {
    return this.root.getAttribute('data-upsell-selected') === 'true';
  };

  ProductUpsellUpload.prototype.setSelected = function (selected) {
    this.root.setAttribute('data-upsell-selected', selected ? 'true' : 'false');
    this.root.classList.toggle('is-selected', !!selected);

    if (this.button) {
      this.button.classList.toggle('is-selected', !!selected);
    }

    var icon = this.button ? this.button.querySelector('.product-upsell-upload__button-icon') : null;
    if (icon) {
      icon.textContent = selected ? '✓' : '+';
    }

    if (this.buttonLabel) {
      this.buttonLabel.textContent = selected ? this.selectedLabel : this.defaultLabel;
    }
  };

  ProductUpsellUpload.prototype.matchesForm = function (form) {
    if (!form || form.closest(ROOT_SELECTOR)) return false;

    var resolved = resolveMainProductForm(this.productId);
    var dataForm = resolveMainDataForm(resolved);

    return form === resolved || form === dataForm;
  };

  ProductUpsellUpload.prototype.setLoading = function (loading) {
    this.isSubmitting = !!loading;

    if (!this.button) return;

    this.button.disabled = !!loading;
    this.button.classList.toggle('is-loading', !!loading);

    if (this.buttonLabel) {
      this.buttonLabel.textContent = loading ? this.loadingLabel : (this.isSelected() ? this.selectedLabel : this.defaultLabel);
    }
  };

  ProductUpsellUpload.prototype.showStatus = function (message) {
    if (!this.statusNode) return;
    this.statusNode.hidden = !message;
    this.statusNode.textContent = message || '';
  };

  ProductUpsellUpload.prototype.showError = function (message) {
    if (!this.errorNode) return;
    this.errorNode.hidden = !message;
    this.errorNode.textContent = message || '';
  };

  ProductUpsellUpload.prototype.clearMessages = function () {
    this.showStatus('');
    this.showError('');
  };

  ProductUpsellUpload.prototype.prepareUpsellState = function () {
    if (!this.upsellVariantId) {
      throw new Error('Variante upsell non trovata.');
    }

    if (!this.uploadSelector && this.uploadRequired) {
      throw new Error('Configura il metafield custom.upload_lift_selector_upsell sul prodotto originale.');
    }

    var collected = snapshotPropertiesFromContainer(this.uploadContainer);
    var configuratorProperties = this.collectConfiguratorProperties();

    if (collected.hasUploadInProgress && !collected.hasUploadValue) {
      throw new Error('Attendi il completamento del caricamento file dell’upsell.');
    }

    if (this.uploadRequired && !collected.hasUploadValue) {
      throw new Error('Completa il caricamento del file richiesto per l’upsell.');
    }

    return {
      id: this.remoteConfiguratorState && this.remoteConfiguratorState.id ? this.remoteConfiguratorState.id : parseInt(this.upsellVariantId, 10),
      quantity: 1,
      properties: Object.assign({}, configuratorProperties, collected.properties),
      hasUploadValue: collected.hasUploadValue
    };
  };

  ProductUpsellUpload.prototype.mountUploadLift = function () {
    var self = this;
    if (!self.uploadContainer || !self.uploadSelector) return;

    var tryMount = function () {
      if (self.uploadMounted) return true;

      var mounted = mountUpsellUploadIntoContainer(self.root, self.uploadContainer, self.uploadSelector);
      if (mounted) {
        self.uploadMounted = true;
        self.bindUploadContentObserver();
        self.syncUploadVisibilityByPosition();
        self.scheduleUploadVisibilitySync();
        if (self.uploadObserver) {
          self.uploadObserver.disconnect();
          self.uploadObserver = null;
        }
        return true;
      }

      return false;
    };

    if (tryMount()) return;

    var attempts = 0;
    var intervalId = window.setInterval(function () {
      attempts += 1;
      if (tryMount() || attempts >= 20) {
        window.clearInterval(intervalId);
      }
    }, 300);

    if (!self.uploadObserver) {
      self.uploadObserver = new MutationObserver(function () {
        tryMount();
      });

      self.uploadObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  };

  ProductUpsellUpload.prototype.bindMainFormInterceptors = function () {
    var self = this;
    var mainForm = resolveMainProductForm(self.productId);
    var dataForm = resolveMainDataForm(mainForm);
    var forms = [];

    if (mainForm) forms.push(mainForm);
    if (dataForm && forms.indexOf(dataForm) === -1) forms.push(dataForm);

    forms.forEach(function (form) {
      if (!form || form.dataset.wsUpsellBound === 'true') return;
      form.dataset.wsUpsellBound = 'true';

      form.addEventListener('submit', function (event) {
        if (!self.isSelected()) return;
        if (event.submitter && event.submitter.closest && event.submitter.closest('.shopify-payment-button')) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        if (typeof event.stopPropagation === 'function') {
          event.stopPropagation();
        }

        self.handleMainSubmit(form, event.submitter || trackedSubmitter || null);
      }, true);

      form.addEventListener('form-submit', function (event) {
        if (!self.isSelected()) return;

        if (event) {
          if (typeof event.preventDefault === 'function') {
            event.preventDefault();
          }
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }
          if (typeof event.stopPropagation === 'function') {
            event.stopPropagation();
          }
        }

        self.handleMainSubmit(form, trackedSubmitter || null);
      }, true);

      toArray(form.querySelectorAll('button[type="submit"], input[type="submit"], [name="add"], [data-product-add-to-cart], .ws-cta__btn')).forEach(function (submitter) {
        if (!submitter || submitter.dataset.wsUpsellBound === 'true') return;
        submitter.dataset.wsUpsellBound = 'true';

        submitter.addEventListener('click', function (event) {
          if (!self.isSelected()) return;
          if (submitter.closest('.shopify-payment-button')) return;
          if (submitter.name === 'checkout') return;

          trackedSubmitter = submitter;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (typeof event.stopPropagation === 'function') {
            event.stopPropagation();
          }

          self.handleMainSubmit(form, submitter);
        }, true);
      });
    });
  };

  ProductUpsellUpload.prototype.handleMainSubmit = function (mainForm, submitter) {
    var self = this;
    if (!self.isSelected() || self.isSubmitting) return Promise.resolve(false);

    if (typeof mainForm.reportValidity === 'function' && !mainForm.reportValidity()) {
      return Promise.resolve(true);
    }

    self.clearMessages();
    self.showStatus('Aggiunta prodotti al carrello...');
    self.setLoading(true);

    return Promise.resolve().then(function () {
      var preparedUpsell = self.preparedUpsell || self.prepareUpsellState();
      var mainData = buildMainProductFormData(mainForm, submitter);
      var shouldAddPreview = wantsPreviewAddon();

      return addMainProduct(mainData).then(function () {
        if (!shouldAddPreview) {
          return null;
        }

        return ensurePreviewAddonData().then(function (previewAddonData) {
          var previewAddonId = parseInt(previewAddonData.id, 10);

          if (!previewAddonId) {
            throw new Error('Variant ID anteprima non trovato.');
          }

          return addUpsellProduct({
            id: previewAddonId,
            quantity: 1,
            properties: buildPreviewAddonProperties(mainForm, mainData)
          });
        });
      }).then(function () {
        return addUpsellProduct(preparedUpsell);
      });
    }).then(function () {
      self.preparedUpsell = null;
      self.setSelected(false);
      window.location.assign('/cart');
      return true;
    }).catch(function (error) {
      self.showStatus('');
      self.showError(error && error.message ? error.message : 'Errore durante l’aggiunta al carrello.');
      return true;
    }).finally(function () {
      self.setLoading(false);
    });
  };

  function initRoots(scope) {
    toArray((scope || document).querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
      if (root.dataset.productUpsellUploadReady === 'true') return;
      root.dataset.productUpsellUploadReady = 'true';
      instances.push(new ProductUpsellUpload(root));
    });
  }

  document.addEventListener('click', function (event) {
    var submitter = event.target && event.target.closest
      ? event.target.closest('button[type="submit"], input[type="submit"], [name="add"], [data-product-add-to-cart], .ws-cta__btn')
      : null;

    if (submitter && submitter.form) {
      trackedSubmitter = submitter;
    }
  }, true);

  document.addEventListener('click', function (event) {
    var submitter = event.target && event.target.closest
      ? event.target.closest('button[type="submit"], input[type="submit"], [name="add"], [data-product-add-to-cart], .ws-cta__btn')
      : null;

    if (!submitter || !submitter.form) return;
    if (submitter.closest(ROOT_SELECTOR)) return;
    if (submitter.closest('.shopify-payment-button')) return;
    if (submitter.name === 'checkout') return;

    var instance = instances.find(function (entry) {
      return entry.matchesForm(submitter.form) && entry.isSelected();
    });

    if (!instance) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    instance.handleMainSubmit(submitter.form, submitter);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !(form instanceof HTMLFormElement)) return;

    var instance = instances.find(function (entry) {
      return entry.matchesForm(form) && entry.isSelected();
    });

    if (!instance) return;

    if (event.submitter && event.submitter.closest && event.submitter.closest('.shopify-payment-button')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    instance.handleMainSubmit(form, event.submitter || trackedSubmitter || null);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRoots(document);
    }, { once: true });
  } else {
    initRoots(document);
  }
})();
